import React, { useEffect, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import ThankYou from './pages/ThankYou';
import { pageview } from './components/tracking/metaPixel';
// Component to handle route changes and track page views
const RouteChangeTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Track page view on route change
    pageview();
    // Debug info
    console.log('Tracking page view for:', location.pathname);
  }, [location]);
  return null;
};
export function AppRouter() {
  useEffect(() => {
    // No inicializamos el pixel aquí, ya se inicializa en meta-pixel.js
    // Track initial page view
    if (window.fbq) {
      pageview();
      console.log('Initial pageview tracked');
    } else {
      console.error('fbq no disponible para tracking inicial');
    }
  }, []);
  return <BrowserRouter data-id="element-14">
      <RouteChangeTracker data-id="element-15" />
      <Routes data-id="element-16">
        <Route path="/" element={<App data-id="element-18" />} data-id="element-17" />
        <Route path="/thank-you" element={<ThankYou data-id="element-20" />} data-id="element-19" />
        <Route path="/gracias.html" element={<ThankYou data-id="element-22" />} data-id="element-21" />
        <Route path="/gracias" element={<ThankYou data-id="element-24" />} data-id="element-23" />
      </Routes>
    </BrowserRouter>;
}